import React, { useEffect, useState } from "react"
import PageLayoutAuth from "./PageLayoutAuth"
import InputDefault from "components/Input/InputDefault"
import FormInputCard from "./molecules/FormInputCard"
import Header from "./atoms/Header"
import { PATH } from "constants/path"
import { InviteSentSignUpRequest } from "./types"
import {
  downLoadBackUpKey,
  isValidEmail,
  isValidPhone,
  parseJwt,
  validationPassword,
} from "helpers/utils"
import { useBoolean, useString, useWindowSize } from "helpers/hooks"
import { cloneDeep, includes } from "lodash"
import {
  checkEmailExist,
  checkUserIsActivatedMiddleware,
  inviteSentSignupMiddleware,
  postSendRecoveryCodeMiddleware,
} from "./services/api"
import { STATUS_RESPONSE } from "types"
import { pushTo, useQuery } from "helpers/history"
import { MESSENGER_NOTIFICATION } from "constants/messenger"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { toast } from "react-toastify"
import { useLocation } from "react-router-dom"
import queryString from "query-string"
import { useChangeLabelStatusInputPasswordAndConfirm } from "./auth.hook"
import FormInputSignUpCard from "./molecules/FormInputSignUpCard"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"
import { ACTION_RECAPTCHA } from "constants/actionReCaptcha"
import RecoveryModal from "./molecules/RecoveryModal"
import { encryptionHelper } from "helpers/encryption"
import InputPhone from "components/Input/InputPhone"
import { DescriptionSecuityCodeCard } from "components/DescriptionSecuityCodeCard"
const InviteSentSignUp = () => {
  const location = useLocation()
  const [request, setRequest] = useState<{
    confirmedPassword: string
    password: string
    fullname: string
    backupKeyCode: string
    phoneNumber: string
    security_code: string
  }>({
    confirmedPassword: "",
    password: "",
    fullname: "",
    backupKeyCode: "",
    phoneNumber: "",
    security_code: "",
  })
  const { isMobile } = useWindowSize()

  const query = useQuery()
  const accessToken = query.get("access_token")
  const tokenPayload = parseJwt(accessToken)

  const projectId = query.get("project")
  const checkbox = useBoolean()
  const isLoading = useBoolean()
  const emailSignUp = useString("example@yopmail.com")
  const verificationToken = useString()
  const openRecoveryModal = useBoolean()
  const {
    statusInputConfirm,
    statusInputPassword,
    getStatusInputConfirm,
    getStatusInputPassword,
  } = useChangeLabelStatusInputPasswordAndConfirm()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const showToolTipSecurityCode = useBoolean()

  useEffect(() => {
    if (emailSignUp.value !== "example@yopmail.com") {
      const validateTokenAsync = async () => {
        const check = await validateToken()
        if (!check) {
          toast(
            <LabelNotificationPage
              messenger={"Invitation link has been expired."}
              type="error"
            />
          )
          pushTo(`/login`)
        }
      }
      validateTokenAsync()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenPayload.payload.project_id, emailSignUp.value])

  useEffect(() => {
    const parsed = queryString.parse(location.search)
    emailSignUp.setValue(parsed?.email)
    verificationToken.setValue(parsed?.token)
    checkIsActivated(parsed?.email as string)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])
  const checkIsActivated = async (email: string) => {
    const isActivated = await checkUserIsActivatedMiddleware(email)
    if (isActivated) {
      persitShareState()
      pushTo(`/login`)
    }
  }

  const handleChangeInput =
    (key: "fullname" | "confirmedPassword" | "password" | "security_code") =>
    (event) => {
      setRequest({
        ...request,
        [key]: event.target.value,
      })

      if (key === "password") {
        if (request.confirmedPassword) {
          getStatusInputConfirm(event.target.value, request.confirmedPassword)
        }
        getStatusInputPassword(event.target.value)
      }
      if (key === "confirmedPassword") {
        getStatusInputConfirm(event.target.value, request.password)
      }
    }
  const handleChangePhoneNumber = (value) => {
    setRequest({
      ...request,
      phoneNumber: value,
    })
  }

  const isValidPhoneNumber = isValidPhone(request.phoneNumber)

  const handleDisableButton = () => {
    const newRequest = cloneDeep(request)
    let isDisable = false
    Object.values(newRequest).forEach((el, index) => {
      if (!el && index !== 3) {
        isDisable = true
      } else {
        switch (Object.keys(newRequest)[index]) {
          case "email":
            isDisable = isValidEmail(el)
            break
          case "password":
            isDisable = !validationPassword(el)
            break
        }
      }
    })
    if (!isValidPhoneNumber) return true
    if (request.security_code.length !== 4) return true
    if (request.password !== request.confirmedPassword) {
      return true
    }
    return isDisable
  }

  const validateToken = async () => {
    if (!accessToken) {
      return false
    }
    const newEmailSignUp = emailSignUp.value
    const { project_build_id, conversation_id, listUser, projectId, email } =
      tokenPayload.payload
    if (
      project_build_id &&
      conversation_id &&
      includes(listUser, newEmailSignUp)
    ) {
      return true
    }
    if (projectId && email && newEmailSignUp === email) {
      return true
    }
    return false
  }

  const persitShareState = () => {
    const persitedData = JSON.stringify({
      accessToken,
      projectId,
      ...tokenPayload?.payload,
    })
    localStorage.setItem("sharedProject", persitedData)
  }

  const onClickButton = async () => {
    if (!checkbox.value) {
      toast(
        <LabelNotificationPage
          messenger={MESSENGER_NOTIFICATION.CHECKBOX_SIGN_UP}
          type="error"
        />
      )
      return
    }
    if (!executeRecaptcha) {
      toast(
        <LabelNotificationPage
          messenger={MESSENGER_NOTIFICATION.RECAPTCHA_AVAILABLE}
          type="error"
        />
      )
      return
    }

    const emailExists = await checkEmailExist(
      emailSignUp.value,
      request.phoneNumber,
      true
    )
    if (emailExists) return

    let backupKeyCode = request.backupKeyCode
    if (!backupKeyCode) {
      backupKeyCode = encryptionHelper.createBackupKey()
      setRequest({ ...request, backupKeyCode: backupKeyCode })
    }
    openRecoveryModal.setValue(true)
    postSendRecoveryCodeMiddleware(
      request.phoneNumber,
      request.security_code,
      request.backupKeyCode,
      emailSignUp.value,
      request.fullname
    )
  }
  const onSubmit = async () => {
    try {
      if (!executeRecaptcha) {
        toast(
          <LabelNotificationPage
            messenger={MESSENGER_NOTIFICATION.RECAPTCHA_AVAILABLE}
            type="error"
          />
        )
        return
      }
      const token = await executeRecaptcha(ACTION_RECAPTCHA.SIGN_UP)
      const dataRequest: InviteSentSignUpRequest = {
        ...request,
        email: emailSignUp.value,
        captcha: token,
      }
      inviteSentSignupMiddleware(
        verificationToken.value,
        dataRequest,
        (typeSignUp: STATUS_RESPONSE, messenger) => {
          isLoading.setValue(false)
          if (typeSignUp === STATUS_RESPONSE.SUCCESS) {
            if (!isValidEmail(emailSignUp.value)) {
              toast(
                <LabelNotificationPage
                  messenger="Email incorrect format!"
                  type="error"
                />
              )
              return
            }
            persitShareState()
            return pushTo(PATH.signingUpMessage)
          }

          toast(
            <LabelNotificationPage messenger={messenger ?? ""} type="error" />
          )
        }
      )
    } catch (error) {
      isLoading.setValue(false)
    }
  }
  const onKeyPress = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === "Enter") {
      event.preventDefault()
      if (handleDisableButton()) {
        return
      }
      onClickButton()
    }
  }

  const onResendEmail = () => {
    postSendRecoveryCodeMiddleware(
      request.phoneNumber,
      request.security_code,
      request.backupKeyCode,
      emailSignUp.value,
      request.fullname
    )
  }
  return (
    <PageLayoutAuth>
      <div className="h-full w-full flex flex-col p-6">
        <Header title="Sign up to Tracelium" />
        <div className="flex flex-col mt-6">
          <p
            className="font-normal"
            style={{
              fontSize: 14,
              lineHeight: "24px",
              color: "#111111",
            }}
          >
            You are signing up an account with the email:
          </p>
          <p
            className="font-semibold"
            style={{
              fontSize: 14,
              lineHeight: "24px",
              color: "#111111",
            }}
          >
            {emailSignUp.value}
          </p>
        </div>

        <div className="mt-6">
          <FormInputCard title="Full Name" required>
            <InputDefault
              value={request.fullname}
              onChange={handleChangeInput("fullname")}
              onKeyPress={onKeyPress}
            />
          </FormInputCard>
          <FormInputCard title="Phone number" required>
            <InputPhone
              value={request.phoneNumber}
              setValue={handleChangePhoneNumber}
              onEnterKeyPress={onKeyPress}
            />
            {request.phoneNumber ? (
              <div className="flex mt-1">
                <p
                  className="font-semibold"
                  style={{
                    color: isValidPhoneNumber ? "#56A012" : "#EA4545",
                    fontSize: 10,
                    lineHeight: "14px",
                  }}
                >
                  {isValidPhoneNumber
                    ? "Valid phone number format!"
                    : "Invalid phone number format!"}
                </p>
              </div>
            ) : null}
          </FormInputCard>
          <FormInputCard
            title="Set up a passcode"
            required
            isTippy
            label={<DescriptionSecuityCodeCard />}
            showToolTip={showToolTipSecurityCode}
            visible={isMobile ? showToolTipSecurityCode.value : undefined}
            onClickOutside={() =>
              isMobile ? showToolTipSecurityCode.setValue(false) : undefined
            }
          >
            <InputDefault
              type="password"
              isPassword
              value={request.security_code}
              onChange={handleChangeInput("security_code")}
              onKeyPress={onKeyPress}
              placeholder="4 characters"
              maxLength={4}
            />
          </FormInputCard>
          <FormInputCard
            title="Password"
            required
            isTippy
            label={MESSENGER_NOTIFICATION.PASSWORD_VALIDATE}
          >
            <InputDefault
              type="password"
              isPassword
              value={request.password}
              onChange={handleChangeInput("password")}
              onKeyPress={onKeyPress}
              status={statusInputPassword.status}
              labelStatus={statusInputPassword.label}
            />
          </FormInputCard>
          <FormInputCard title="Confirm password" required>
            <InputDefault
              type="password"
              isPassword
              value={request.confirmedPassword}
              onChange={handleChangeInput("confirmedPassword")}
              onKeyPress={onKeyPress}
              status={statusInputConfirm.status}
              labelStatus={statusInputConfirm.label}
            />
          </FormInputCard>
        </div>
        <FormInputSignUpCard
          checkbox={checkbox}
          onClickButton={onClickButton}
          handleDisableButton={handleDisableButton()}
        />
      </div>
      {openRecoveryModal.value && request.backupKeyCode && (
        <RecoveryModal
          handleDisplayCloseIcon={() => () => openRecoveryModal.setValue(false)}
          backUpKey={request.backupKeyCode}
          cancelText="Download"
          onCloseModal={() => {
            downLoadBackUpKey(
              request.backupKeyCode,
              emailSignUp.value,
              request.phoneNumber,
              request.security_code
            )
          }}
          onResendEmail={onResendEmail}
          submitText="Continue"
          onClickSubmit={onSubmit}
        />
      )}
    </PageLayoutAuth>
  )
}
export default InviteSentSignUp
